var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import subscribeToNewsletterMutation from '@jetshop/core/data/mutations/subscribeToNewsletter.gql';
import React from 'react';
import { Mutation } from 'react-apollo';
const SubscribeToNewsletter = (_a) => {
    var { children, onError = () => { }, onCompleted = () => { } } = _a, props = __rest(_a, ["children", "onError", "onCompleted"]);
    return (React.createElement(Mutation, Object.assign({ onError: onError, onCompleted: onCompleted, mutation: subscribeToNewsletterMutation }, props), (mutate, result) => {
        return children((email) => {
            return mutate({
                variables: {
                    email
                }
            });
        }, result);
    }));
};
export default SubscribeToNewsletter;
//# sourceMappingURL=SubscribeToNewsletter.js.map